module.exports = __webpack_public_path__ + "static/img/6设计师1.5367e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/6设计师1.png
// module id = Twkk
// module chunks = 1